module.exports = __webpack_public_path__ + "static/media/new-map-logo.86ad6069.svg";